























import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator';
import { MetaInfo } from 'vue-meta';
import { RobotOption } from '@/models/MetaTags';
import { BusyObject } from '@/models/Busy';
import { BrandsService, Brand as ApiBrand } from '@/api/braendz';

import LoadingView from '@/components/Spinner/LoadingView.vue';
import BrandDetails from '@/components/Brands/BrandDetails.vue'

@Component({
    components: {
        LoadingView,
        BrandDetails
    },
    metaInfo() {
        return {
            title: this.$i18n.t("brand.view.title", { brandName: (this as unknown as Brand)?.brand?.object?.name ?? this.$i18n.t('brand.view.brandNameLoading') }).toString(),
            meta: [
                { name: 'robots', content: [RobotOption.NoIndex, RobotOption.NoFollow].join(',') }
            ]
        };
    }
})
export default class Brand extends Vue {
    // Member
    public brand = new BusyObject<ApiBrand>();
    
    // Properties
    @Prop({ required: true, type: String }) 
    public id!: string;

    // Lifecycle Methods:
    public mounted(): void {
        this.initBrand(this.id);
    }

    // Methods:
    public async initBrand(id: string): Promise<void> {
        await this.brand.load(async () => {
            return await BrandsService.getBrand(id);
        });
    }
}
